export default __webpack_public_path__ + "static/media/8980ed7a9779ec56.b292b2b60b6fb6ae43b461cc09473b81.svg";